module.exports = wp.blockEditor;


//////////////////
// WEBPACK FOOTER
// external "wp.blockEditor"
// module id = 1
// module chunks = 0